import { apiClient } from "./client";

// Backend reads behind the admin price-table pages (Generic items, Ink prices,
// Curated prices); their writes are services/adminCrud.ts. apiClient comes
// through the api/client barrel, so suites that mock the barrel still see
// these requests. Each resolves to the response body.

/** One page of generic items; `params` is the page's query string. */
export const fetchGenericItems = async (params: URLSearchParams) => {
  const response = await apiClient.get(`/generic-items?${params.toString()}`);
  return response.data;
};

/** Every generic-item category. */
export const fetchGenericCategories = async () => {
  const response = await apiClient.get("/generic-items/categories");
  return response.data;
};

/** One page of ink prices; `params` is the page's query string. */
export const fetchInkPrices = async (params: URLSearchParams) => {
  const response = await apiClient.get(`/ink-prices?${params.toString()}`);
  return response.data;
};

/** One page of one curated price table. */
export const fetchCuratedPrices = async <T>(categoryKey: string, params: URLSearchParams): Promise<T> => {
  const response = await apiClient.get<T>(`/curated-prices/${categoryKey}?${params.toString()}`);
  return response.data;
};

/** One page of general items (curated_item_prices); `params` is the page's query string. */
export const fetchGeneralItems = async (params: URLSearchParams) => {
  const response = await apiClient.get(`/curated-item-prices?${params.toString()}`);
  return response.data;
};

/** Every general-item category. */
export const fetchGeneralItemCategories = async () => {
  const response = await apiClient.get("/curated-item-prices/categories");
  return response.data;
};
